import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IClientAccounts } from '@interfaces/models/client-accounts.interface';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments';
import { State } from '@store/reducers/index';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientAccountsService {
  constructor(
    private http: HttpClient,
    private store: Store<State>,
  ) {}

  getClientAccounts(): Observable<IClientAccounts> {
    return this.http.get<IClientAccounts>(`secure/client-accounts`).pipe(
      catchError((error) => {
        return throwError(error.message);
      }),
    );
  }
}
